import { cn } from "@theprelude/core";
import { useId } from "react";

export const VectrIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => {
  const clipPathId = useId();

  return (
    <svg
      className={cn("size-4 flex-shrink-0", className)}
      {...props}
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M21.3457 23.6768C19.05 23.7101 17.8871 22.4307 16.6343 21.2711C13.9554 18.7922 11.7863 18.389 9.36068 20.0017C8.21783 20.7613 7.25156 21.7743 6.1287 22.5673C5.3257 23.1337 4.39942 23.5302 3.52645 24C3.34985 23.8667 3.17659 23.7334 3 23.6002C3.54644 21.2945 4.08621 18.9888 4.64598 16.6897C4.6793 16.5531 4.8459 16.4065 4.98584 16.3465C7.41483 15.3403 7.94794 13.1045 8.54769 10.9354C9.43732 7.72012 10.257 4.4848 11.1733 1.27947C11.3099 0.799667 11.8197 0.423157 12.1562 0C12.496 0.426489 13.0092 0.802999 13.1458 1.28613C14.1987 4.9646 15.1749 8.66639 16.1778 12.3582C16.6243 13.9975 17.3374 15.4336 19.0133 16.1933C19.2865 16.3165 19.5964 16.6164 19.6697 16.8896C20.2461 19.0887 20.7659 21.3045 21.3424 23.6768H21.3457Z" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="24" height="24" transform="translate(0 0.213257)" />
        </clipPath>
      </defs>
    </svg>
  );
};
